const TEST_IDS = {
    header: {
        downloadPayroll: 'button-download-payroll',
        generateCertificateDrawer: 'button-open-generate-certificate-drawer'
    },
    extraFilters: {
        cuil: 'filter-cuil',
        name: 'filter-name',
        surname: 'filter-surname',
        contract: 'filter-contract',
        state: 'filter-state'
    },
    generationForm: {
        includesClause: 'check-includes-clause',
        destinationCompanyName: 'input-destination-company-name',
        destinationCuit: 'input-destination-company-cuit',
        selectedOrganism: 'selected-organism',
        employeesListSelector: 'combo-employees-list-selector',
        employeesQuantity: 'employees-quantity',
        radioSomeEmployees: 'radio-some-employees',
        radioAllEmployees: 'radio-all-employees',
        commission: {
            companyName: 'commission-company-name',
            domicile: 'commission-domicile',
            startDate: 'commission-start-date',
            endDate: 'commission-end-date',
            province: 'commission-province',
            city: 'commission-city'
        },
        buttons: {
            generateCertificate: 'button-download-certificate',
            cancel: 'button-cancel'
        }
    }
};

const BATCHES_TEST_IDS = {
    main: {
        page: {
            title: 'batches-main-title',
            tabs: 'batches-main-tabs',
            tabPendingPrestador: 'batches-main-tab-pending-prestador',
            tabInProgress: 'batches-main-tab-in-progress',
            tabClosed: 'batches-main-tab-closed',
            massiveSelection: 'batches-main-massive-selection',
            massiveSelectAssignButton: 'batches-main-massive-selection-assign-button',
            table: 'batches-main-table',
            rowSelectPrefix: 'batches-main-row-select-'
        },
        tableActions: {
            viewEmployeesPrefix: 'batches-table-action-view-employees-',
            assignPrestadorPrefix: 'batches-table-action-assign-prestador-',
            changePrestadorPrefix: 'batches-table-action-change-prestador-',
        },
        extraFilters: {
            establishment: 'batches-filter-establishment',
            client: 'batches-filter-client',
            contract: 'batches-filter-contract',
            organism: 'batches-filter-organism',
            state: 'batches-filter-state',
            province: 'batches-filter-province',
            city: 'batches-filter-city',
            type: 'batches-filter-type',
            medicalPrestador: 'batches-filter-medical-prestador',
            expiration: 'batches-filter-expiration'
        }
    },
    dialogs: {
        changePrestador: {
            root: 'batches-dialog-change-prestador',
            close: 'batches-dialog-change-prestador-close',
            cancel: 'batches-dialog-change-prestador-cancel',
            confirm: 'batches-dialog-change-prestador-confirm'
        }
    },
    drawers: {
        assignPrestador: {
            province: 'batches-drawer-assign-prestador-province',
            locality: 'batches-drawer-assign-prestador-locality',
            providerName: 'batches-drawer-assign-prestador-provider-name',
            providerOptionPrefix: 'batches-drawer-assign-prestador-provider-option-',
            cancelButton: 'batches-drawer-assign-prestador-cancel',
            assignButton: 'batches-drawer-assign-prestador-assign'
        },
        asistencia: {
            attendanceStatus: 'batches-drawer-asistencia-attendance-status',
            cancelButton: 'batches-drawer-asistencia-cancel',
            confirmButton: 'batches-drawer-asistencia-confirm'
        },
        medicalAudit: {
            uploadFileButton: 'batches-drawer-medical-audit-upload-file',
            confirmUploadButton: 'batches-drawer-medical-audit-confirm-upload',
            pendingFileExamSelectPrefix: 'batches-drawer-medical-audit-pending-exam-select-',
            pendingFileRemovePrefix: 'batches-drawer-medical-audit-pending-file-remove-',
            existingFileViewPrefix: 'batches-drawer-medical-audit-existing-file-view-',
            examAptitudeSelectPrefix: 'batches-drawer-medical-audit-exam-aptitude-select-',
            examObservationsPrefix: 'batches-drawer-medical-audit-exam-observations-',
            cancelButton: 'batches-drawer-medical-audit-cancel',
            saveButton: 'batches-drawer-medical-audit-save'
        }
    },
    batchDetail: {
        page: {
            headerCard: 'batches-detail-header-card',
            tableContainer: 'batches-detail-table-container',
            table: 'batches-detail-table',
            rowSelectPrefix: 'batches-detail-row-select-',
            actionHistoryPrefix: 'batches-detail-action-history-',
            actionAuditPrefix: 'batches-detail-action-audit-',
            actionAssignShiftPrefix: 'batches-detail-action-assign-shift-'
        },
        filters: {
            search: 'batches-detail-filter-search',
            managementStatus: 'batches-detail-filter-management-status',
            assistanceStatus: 'batches-detail-filter-assistance-status'
        },
        dialog: {
            root: 'batches-detail-derived-dialog',
            reason: 'batches-detail-derived-dialog-reason',
            cancel: 'batches-detail-derived-dialog-cancel',
            confirm: 'batches-detail-derived-dialog-confirm',
            close: 'batches-detail-derived-dialog-close'
        }
    }
};

export { TEST_IDS, BATCHES_TEST_IDS };
